export const environment = {
  production: false,
  providerId: 12,
  samlApp: 'one',
  appConfig: {
    environment: 'QA',
    useLiveReload: false,
    useLocalHost: false,
    useExternalLocalHost: true,
    externalHostAddr: 'https://api-qa.huddy.io'
  },
};
